import Axios from 'axios'
import _ from 'lodash'
import { vueAppApiBaseAddress } from '@/utils/mixins'

var initialState = {
  termsAndConditions: null
}

export const state = _.cloneDeep(initialState)

export const getters = {
  isReacceptanceNeeded: state => {
    const termsAndConditions = state.termsAndConditions
    if (!termsAndConditions) return false
    if (termsAndConditions.isReacceptanceNeeded) return true
    return termsAndConditions.acceptedVersion !== termsAndConditions.currentVersion
  }
}

export const mutations = {
  setTermsAndConditions(state, termsAndConditions) {
    state.termsAndConditions = termsAndConditions
  }
}

export const actions = {
  async getTermsAndConditions({ commit }) {
    const response = await Axios.get(vueAppApiBaseAddress() + `v6/Beehive/termsAndConditions`, {
      withCredentials: true
    })
    commit('setTermsAndConditions', response.data)
    return response
  },
  async updateTermsAndConditions({ commit }, hasAccepted) {
    const response = await Axios.patch(
      vueAppApiBaseAddress() + `v6/Beehive/termsAndConditions`,
      { hasAccepted },
      {
        withCredentials: true
      }
    )
    commit('setTermsAndConditions', response.data)
    return response
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
